import { render, staticRenderFns } from "./FormItemCollection2.vue?vue&type=template&id=05bb4b65&scoped=true"
import script from "./FormItemCollection2.vue?vue&type=script&lang=js"
export * from "./FormItemCollection2.vue?vue&type=script&lang=js"
import style0 from "./FormItemCollection2.vue?vue&type=style&index=0&id=05bb4b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb4b65",
  null
  
)

export default component.exports